import MRitualMatchActionDialog from './MRitualMatchActionDialog.vue';

export { MRitualMatchActionDialog };
export default MRitualMatchActionDialog;
